import React, { memo } from 'react';
import { useStyles } from './styles';

import { ReactComponent as WarningIcon } from 'assets/icons/Warning.svg';

interface IWarningProps {
  text: React.ReactNode;
  styleClass?: string;
}

const Warning = ({ text, styleClass }: IWarningProps) => {
  const classes = useStyles();
  return (
    <div className={`${classes.warningContainer} ${styleClass || ''}`}>
      <WarningIcon className={classes.warningIcon} />
      <p className={classes.warningText}>{text}</p>
    </div>
  );
};

export default memo(Warning);
